import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h1`
	text-align: center;
	color: ${helpers.color.text};
	margin: 42px 0 24px;
	line-height: 36px;
`
